/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

/*
 * Relation options for the onboarding "circle of trust" step. Relation is a
 * plain string (the custom option is free text) — there is NO proximity /
 * location / tier semantics attached. The same string is stored on both the
 * emergency-contact record and the SafeCircle member's `relation` field.
 */

/** The preset, tappable relation chips (in display order). */
export const PRESET_RELATIONS = [
  "Mom",
  "Dad",
  "Brother/Sister",
  "Best friend",
  "My person",
  "Roommate",
  "My 3 AM call",
  "Partner in crime",
] as const;

/** Sentinel chip that reveals the custom free-text input. */
export const CUSTOM_RELATION_LABEL = "Something else…";

/**
 * Resolve the relation string to store. For a preset, returns the preset
 * label. For the custom sentinel, returns the trimmed free text (or null if
 * the user left it blank — relation is optional on the stored record).
 */
export function resolveRelation(
  selected: string | null,
  customText: string,
): string | null {
  if (!selected) return null;
  if (selected === CUSTOM_RELATION_LABEL) {
    const trimmed = customText.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  return selected;
}
